'use strict';
import svgxuse from 'svgxuse/svgxuse.min.js';

export default class Footer {
  constructor() {

  }
}
